
import xss from 'xss';
import commonUtil from '../../common-util';
import { changeLevelType } from './const';
import { getQuesLevel} from './ques.service';
const i18n = commonUtil.i18n;

/**
 * 通用的错误处理方法
 * @param {Object} error 错误信息
 */
export const handleError = function(error) {
  if (error && error.error) {
    // 兼容处理
    error = error.error;
  }
  if (error) {
    if (error.key && error.key.indexOf('global.token') >= 0) {
      return; // 不弹出token错误
    }
    let msg = error.message;
    this.$message({
      message: msg,
      type: 'error'
    });
  }
};

export const htmlEncode = function(str) {
  if (str === undefined || str === null || str.length === 0) return '';
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/ /g, '&nbsp;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;')
    .replace(/·/g, '&#183;');
  // .replace(/\\/g, `\\\\`)
  // .replace(/%/g, `%25`)
};
export const htmlDecode = function(str) {
  if (str === undefined || str === null || str.length === 0) return '';
  return str
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&nbsp;/g, ' ')
    .replace(/&#39;/g, '\'')
    .replace(/&quot;/g, '"')
    .replace(/&#183;/g, '·');
  // .replace(/\\\\/g, `\\`)
  // .replace(/%25/g, `%`)
};

/**
 * 数字转字母
 * @param {number} num 数字
 */
export const convertASCIIForNum = (num, lower) => {
  let itemCode = '';
  num = num + 65;
  if (num > 64 && num < 91) {
    itemCode = String.fromCharCode(num + (lower ? 32 : 0));
  }
  return itemCode;
};

/**
 * 获取题号的名称。中文：一二三...  英文：Ⅰ Ⅱ Ⅲ Ⅳ Ⅴ...
 * 支持至百位
 * @param {number} num 题号
 */
export const getQuesTypeIndexName = (num) => {
  let newNum = '';
  const lan = commonUtil.getLanguage();
  switch (lan) {
    case 'zh':// 简体
    case 'ha':// 繁体
      const KEYS_LAN_CH_NUM = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']; //  lan === 'zh' ? ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九'] : ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
      const KEYS_LAN_CH_UNIT = lan === 'zh' ? ['', '十', '百', '千', '万'] : ['', '十', '百', '千', '萬'];
      const strArr = num.toString().split('').reverse();
      for (let i = 0; i < strArr.length; i++) {
        newNum = (
          (i === 0 && strArr[i] === '0') || (i > 0 && strArr[i] === '0' && strArr[i - 1] === '0')
            ? ''
            : (
              strArr[i] === '0'
                ? KEYS_LAN_CH_NUM[0]
                : (
                  KEYS_LAN_CH_NUM[strArr[i]] + KEYS_LAN_CH_UNIT[i]
                )
            )) + newNum;
      }
      return newNum;
    default:
      // 英文
      const k = Math.floor(num / 1000);
      const h = Math.floor((num % 1000) / 100);
      const t = Math.floor((num % 100) / 10);
      const o = num % 10;
      const KEYS_LAN_LM_ONE = ['I', 'II', 'III', 'IV', 'V', 'VI', 'VII', 'VIII', 'IX'];
      const KEYS_LAN_LM_TEN = ['X', 'XX', 'XXX', 'XL', 'L', 'LX', 'LXX', 'LXXX', 'XC'];
      const KEYS_LAN_LM_HUN = ['C', 'CC', 'CCC', 'CD', 'D', 'DC', 'DCC', 'DCCC', 'CM'];
      const KEYS_LAN_LM_THO = 'M'; // 千位以上有点问题
      for (let i = 0; i < k; i++) {
        newNum += KEYS_LAN_LM_THO;
      }
      if (h) {
        newNum += KEYS_LAN_LM_HUN[h - 1];
      }
      if (t) {
        newNum += KEYS_LAN_LM_TEN[t - 1];
      }
      if (o) {
        newNum += KEYS_LAN_LM_ONE[o - 1];
      }
      return newNum;
  }
};

/**
 * 处理换行符
 * @param {String} txt 文本
 * @param {Boolean} [isNotHtml] 是否非Html内容
 */
export const dealLineFeed = (txt, isNotHtml) => {
  if (txt) {
    if (isNotHtml) {
      txt = htmlEncode(txt); // 对多行文本就行编码预防xss
    }
    // 去掉所有的换行符
    txt = txt.replace(/\r\n/g, '<br />');
    txt = txt.replace(/\r/g, '<br />');
    txt = txt.replace(/\n/g, '<br />');
  }
  return txt;
};

/**
 * 闭包节流函数(防止频繁操作请求API)
 * @param {object} fn 执行方法
 * @param {number} delay 延迟时间
 */
export const throttle = function(fn, delay) {
  let timer = null;
  return () => {
    clearTimeout(timer);
    timer = setTimeout(() => {
      fn.apply(this, arguments);
    }, delay);
  };
};

const replaceAllName = String.prototype.ReplaceAll ? 'ReplaceAll' : 'replaceAll';
/**
 * 处理文本、富文本内容
 * @param {String} str 富文本内容
 * @param {Boolean} [isInLine] 是否需要在行内显示，此时需要处理第一个p
 */
export const cleanStyle = function(str, isInLine) {
  if (!str) {
    return '';
  }
  if (str) {
    if (str.indexOf('<p>') === 0 && str.indexOf('<p>') === str.lastIndexOf('<p>')) {
      // 单个纯粹的P, 直接去除。当成纯文本
      str = str.replace('<p>', '').replace('</p>', '');
    } else if (isInLine) {
      // 兼容处理监控报错，处理 replaceAllName 为 function的情况
      if (typeof str[replaceAllName] === 'function') {
        // 需要在行内展示的情况： A. ******
        // 处理原P标签，无样式的默认行替换掉第一行实现ABCD插入, 同时处理间距和富文本保持一致
        str = str.replace('<p>', '').replace('</p>', '')[replaceAllName]('<p>', '<p class="mv10">');
      } else {
        str = str.replace('<p>', '').replace('</p>', '');
        str = str.replace(/<p>/g, '<p class="mv10">');
      }
    } else {
      if (typeof str[replaceAllName] === 'function') {
        // 其余情况 去除顶部margin-top来对其，同时处理间距和富文本保持一致
        str = str.replace('<p>', '<p class="mt0 mb10" style="margin-top: 0px">')[replaceAllName]('<p>', '<p class="mv10">');
      } else {
        str = str.replace('<p>', '<p class="mt0 mb10" style="margin-top: 0px">');
        str = str.replace(/<p>/g, '<p class="mv10">');
      }
    }
  }
  // // 去除图片中style样式
  // let reg = /(<img.+?>)/g
  // if (str && reg.test(str)) {
  //   str = str.replace(reg, (pattern) => {
  //     return pattern.replace(/\s+style="[^"]*"/g, ' ')
  //   })
  // }
  // 替换&nbsp; 单个空格留空格 多个每2个替换为 空格+&nbsp;
  const reg1 = /&nbsp;/g;
  const reg2 = / {2}/g;
  if (str) {
    str = str.replace(reg1, ' ');
    str = str.replace(reg2, ' &nbsp;');
  }
  // \r\n 改成<br>自动换行
  return dealLineFeed(str);
};

/**
 * 防抖
 * @param {*} fn
 * @param {*} delay
 * @param {*} immediate
 * @returns
 */
export const debounce = (fn, delay, immediate) => {
  let timer;
  let result;
  return function(...args) {
    if (timer) clearTimeout(timer);

    if (immediate) {
      // 如果timer存在，说明第二次调用的时候还没到delay时间，因为如果超过delay时间
      // timer会被赋值为null，所以这个时候我们不应该执行fn，应该重新设置一个定时器
      // 但如果是一次的时候，因为还没有设过定时器，所以这里timer会是undefined
      if (timer) {
        timer = setTimeout(() => { timer = null; }, delay);
      } else {
        result = fn.apply(this, args);
        return result;
      }
    } else {
      timer = setTimeout(() => fn.apply(this, args), delay);
    }
  };
};

/**
 * 节流
 * @param {*} fn
 * @param {*} wait
 * @param {*} immediate
 * @returns
 */
export const throttling = (fn, wait, immediate) => {
  let timer;
  let context, args;

  const run = () => {
    timer = setTimeout(() => {
      if (!immediate) {
        fn.apply(context, args);
      }
      clearTimeout(timer);
      timer = null;
    }, wait);
  };

  return function() {
    context = this;
    args = arguments;
    if (!timer) {
      // throttle, set
      if (immediate) {
        fn.apply(context, args);
      }
      run();
    } else {
      // throttle, ignore
    }
  };
};

// 生成四位随机数
function S4() {
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
// 生成Guid
export const getGuid = () => (S4() + S4() + '-' + S4() + '-' + S4() + '-' + S4() + '-' + S4() + S4() + S4());

// 获取纯文本内容
export const getSafeHtmlContent = (s) => {
  s = xss(s);
  const div = document.createElement('div');
  div.innerHTML = s;
  return div.innerText || div.textContent;
};

// 去除html标记
export const replaceHtmlTags = (s) => {
  s = filterXss(s);
  const div = document.createElement('div');
  div.innerHTML = s;
  return div.innerText || div.textContent;
};

/**
 * 过滤xss攻击代码
 * @param {String} text 文本
 */
export const filterXss = (text) => {
  if (!text) {
    return '';
  }

  // 去掉script标签
  text = text.replace(/<script[\s\S]*?(<\/script>|\/>)/ig, '');
  // 去除on事件
  const onTagReg = /<[^>]*?( |\/)(on[\W\w]*?=([""'])?([^'""]+)([""'])?)[\S\s]*?>/ig;
  const onReg = /( |\/)on[\W\w]*?=([""'])?([^'""]+)([""'])?/ig;
  let onMatches = onTagReg.exec(text);
  while (onMatches) {
    text = text.replace(onMatches[0], onMatches[0].replace(onReg, ''));
    onMatches = onTagReg.exec(text);
  }
  // 去除非链接href
  const hrefReg = /<a[^>]*(href=([""']?([^'""]+)([""'])?))[\S\s]*?>/ig;
  let hrefMatches = hrefReg.exec(text);
  while (hrefMatches) {
    hrefMatches[3].indexOf('http') !== 0 && (text = text.replace(hrefMatches[0], hrefMatches[0].replace(hrefMatches[1], '')));
    hrefMatches = hrefReg.exec(text);
  }
  // 去除eval(...)和expression(...)
  text = text.replace(/(eval|expression)\(.*?\)/ig, '');

  return text;
};

/**
 * 初始化试题
 * @param {*} type 题型
 * @returns
 */
export const initQues = (type, libId, libName) => {
  switch (type) {
    case 0:
      return {
        content: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'), // 判断是不是存在标题，使用全局标题
        summary: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        libId: libId || '',
        libName: libName || '',
        pointIds: [],
        levelType: 0,
        type: type,
        deletedDate: null,
        auditUserId: '',
        auditFullname: '',
        auditTime: null,
        auditInfo: '',
        answer: '',
        explainText: '',
        explainPlay: {
          fileId: '',
          fileName: '',
          fileType: '',
          playDetails: []
        },
        itemAnswerObj: [],
        questionItems: [
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 1,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          },
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 2,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          },
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 3,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          },
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 4,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          }
        ]
      };
    case 1:
      return {
        content: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        summary: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        libId: libId || '',
        libName: libName || '',
        pointIds: [],
        levelType: 0,
        type: type,
        deletedDate: null,
        auditUserId: '',
        auditFullname: '',
        auditTime: null,
        auditInfo: '',
        answer: [],
        explainText: '',
        explainPlay: {
          fileId: '',
          fileName: '',
          fileType: '',
          playDetails: []
        },
        itemAnswerObj: [],
        questionItems: [
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 1,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          },
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 2,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          },
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 3,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          },
          {
            id: getGuid(),
            itemContent: i18n.t('pc_biz_ote_lbl_defaulttopicdry'),
            answer: 0,
            orderIndex: 4,
            itemPlay: {
              fileId: '',
              fileName: '',
              fileType: '',
              playDetails: []
            }
          }
        ]
      };
    case 2:
      return {
        content: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        summary: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        libId: libId || '',
        libName: libName || '',
        pointIds: [],
        judgeCorrectOptionContent: i18n.t('pc_biz_ote_lbl_wright'),
        judgeWrongOptionContent: i18n.t('pc_biz_ote_lbl_wrong'),
        levelType: 0,
        type: type,
        deletedDate: null,
        auditUserId: '',
        auditFullname: '',
        auditTime: null,
        auditInfo: '',
        answer: 1,
        judgeAnswer: 1,
        explainText: '',
        explainPlay: {
          fileId: '',
          fileName: '',
          fileType: '',
          playDetails: []
        },
        itemAnswerObj: [],
        questionItems: [{
          id: 1 // 正确
        }, {
          id: 0
        }]
      };
    case 3:
      return {
        content: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        summary: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        libId: libId || '',
        libName: libName || '',
        pointIds: [],
        levelType: 0,
        type: type,
        deletedDate: null,
        auditUserId: '',
        auditFullname: '',
        auditTime: null,
        auditInfo: '',
        answer: '',
        explainText: '',
        explainPlay: {
          fileId: '',
          fileName: '',
          fileType: '',
          playDetails: []
        },
        noOrderMark: 0,
        itemAnswerObj: [{ itemAnswer: i18n.t('pc_biz_ote_lbl_dragquestionsdefault') }],
        fillItems: [{
          itemAnswer: i18n.t('pc_biz_ote_lbl_dragquestionsdefault'),
          itemAnswer1: '',
          itemAnswer2: '',
          itemAnswer3: '',
          itemAnswer4: '',
          itemAnswer5: ''
        }]
      };
    case 4:
      return {
        keywords: [{ name: i18n.t('pc_biz_ote_lbl_keyword'), rate: '' }],
        content: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        summary: i18n.t('pc_biz_ote_lbl_questionsdefaulttopic'),
        libId: libId || '',
        libName: libName || '',
        pointIds: [],
        levelType: 0,
        type: type,
        deletedDate: null,
        auditUserId: '',
        auditFullname: '',
        auditTime: null,
        auditInfo: '',
        answer: '',
        answerContent: '',
        answerPlay: {
          fileId: '',
          fileName: '',
          fileType: '',
          playDetails: []
        },
        explainText: '',
        explainPlay: {
          fileId: '',
          fileName: '',
          fileType: '',
          playDetails: []
        },
        itemAnswerObj: [],
        questionItems: []
      };
    default:
      break;
  }
};

/**
 * 初始化机构的试题难度类型
 */
export const initQuesLevelType = async(cb) => {
  try {
    const orgId = window.localStorage.orgId;
    const levelTypeAll = window.sessionStorage.ote_level_type_all || '';

    if (!orgId) return false;

    if (levelTypeAll && levelTypeAll.indexOf(orgId) === 0) {
      changeLevelType(levelTypeAll.split('_')[1] === '1', cb);
      return true;
    }

    await getQuesLevel().then(res => {
      window.sessionStorage.ote_level_type_all = `${orgId}_${res && res.fiveLevel ? 1 : 0}`;
      changeLevelType(res && res.fiveLevel, cb);
      return true;
    });
  } catch (error) {
  }
};
